// QuickActionCardV3 — large CTA card with gradient overlay + icon.
import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";

export default function QuickActionCardV3({
    testId,
    title,
    subtitle,
    href,
    icon: Icon,
    gradientFrom,
    gradientTo,
    delay = 0,
}) {
    return (
        <motion.div
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.35, delay }}
        >
            <Link
                to={href}
                data-testid={testId}
                className="group relative overflow-hidden rounded-2xl border p-5 flex items-center gap-4 transition-colors no-underline"
                style={{ backgroundColor: "#111111", borderColor: "#1A1A1A" }}
                onMouseEnter={(e) => (e.currentTarget.style.borderColor = "#FFFFFF")}
                onMouseLeave={(e) => (e.currentTarget.style.borderColor = "#1A1A1A")}
            >
                {/* Gradient wash */}
                <div
                    aria-hidden
                    className="absolute inset-0 opacity-30 group-hover:opacity-45 transition-opacity"
                    style={{
                        background: `linear-gradient(135deg, ${gradientFrom} 0%, transparent 60%)`,
                    }}
                />
                <span
                    className="relative h-11 w-11 rounded-xl grid place-items-center shrink-0"
                    style={{
                        background: `linear-gradient(135deg, ${gradientFrom} 0%, ${gradientTo} 100%)`,
                    }}
                >
                    <Icon className="h-5 w-5 text-white" aria-hidden />
                </span>
                <div className="relative flex-1 min-w-0">
                    <p className="text-sm font-semibold text-[#FFFFFF]">{title}</p>
                    <p className="mt-0.5 text-xs text-[#CCCCCC] truncate">{subtitle}</p>
                </div>
                <ArrowRight
                    className="relative w-4 h-4 text-[#CCCCCC] group-hover:text-[#FFFFFF] group-hover:translate-x-0.5 transition-all shrink-0"
                    aria-hidden
                />
            </Link>
        </motion.div>
    );
}
